export default __webpack_public_path__ + "29b39089170885ae29671a8c66d85a9f.woff";